/* KoaClad: lift the 250-variant cap in {{ product | json }}.
   Products with >250 variants carry a compact map in the koaclad.variant_map
   metafield, rendered as <script data-variant-map> inside the product form.
   This wraps Shopify.OptionSelectors so every init path (product page,
   quick-shop) swaps in the complete variant list and fills the master
   <select name="id"> with the missing options. No map = original behavior. */
(function () {
  function expandVariants(mapData, baseProduct) {
    var sizes = mapData.o1;
    var finishes = mapData.o2;
    return mapData.v.map(function (row) {
      var o1 = sizes[row[1]];
      var o2 = finishes[row[2]];
      var title = o1 + ' / ' + o2;
      return {
        id: row[0], title: title, option1: o1, option2: o2, option3: null,
        sku: null, requires_shipping: true, taxable: true, featured_image: null,
        available: true, name: baseProduct.title + ' - ' + title,
        public_title: title, options: [o1, o2], price: row[3], weight: 0,
        compare_at_price: null, inventory_management: null, barcode: null,
        quantity_rule: { min: 1, max: null, increment: 1 },
        quantity_price_breaks: [], requires_selling_plan: false,
        selling_plan_allocations: []
      };
    });
  }

  function applyMap(selectId, opts) {
    var sel = document.getElementById(selectId);
    var formEl = sel && sel.closest('[data-product-form]');
    var mapEl = formEl && formEl.querySelector('script[data-variant-map]');
    if (!mapEl || !opts || !opts.product || !opts.product.variants) return;

    var mapData = JSON.parse(mapEl.textContent);
    if (!mapData || !mapData.v || mapData.v.length <= opts.product.variants.length) return;

    var full = expandVariants(mapData, opts.product);
    opts.product = Object.assign({}, opts.product, { variants: full });

    var have = {};
    for (var i = 0; i < sel.options.length; i++) have[sel.options[i].value] = true;
    full.forEach(function (v) {
      if (!have[String(v.id)]) {
        var o = document.createElement('option');
        o.value = v.id;
        o.textContent = v.title;
        sel.appendChild(o);
      }
    });
  }

  function patch() {
    if (!window.Shopify || !Shopify.OptionSelectors || Shopify.OptionSelectors.__variantMapPatched) return;
    var Orig = Shopify.OptionSelectors;
    var Patched = function (selectId, opts) {
      try {
        applyMap(selectId, opts);
      } catch (e) {
        if (window.console) console.error('variant-map: expand failed', e);
      }
      return Orig.call(this, selectId, opts);
    };
    Patched.prototype = Orig.prototype;
    for (var k in Orig) {
      if (Object.prototype.hasOwnProperty.call(Orig, k)) Patched[k] = Orig[k];
    }
    Patched.__variantMapPatched = true;
    Shopify.OptionSelectors = Patched;
  }

  patch();
  document.addEventListener('DOMContentLoaded', patch);
})();
